import { BaseBudget } from 'typings'
import { useFormStateContext } from 'ui'
import { ProgressiveDiscountPromotion } from '../../typings'
import { Summary } from './Summary'
import { Alerts } from './Summary/Alerts'

export function ProgressiveDiscount() {
  const { form, discountType } = useFormStateContext()

  const {
    conditions,
    general,
    restrictions,
    scheduling,
    progressive,
  }: ProgressiveDiscountPromotion = form.getValues()

  return (
    <>
      <Alerts>
        <Alerts.ProgressiveDiscountRecap progressive={progressive} />
        <Alerts.AffectedProducts />
      </Alerts>

      <Summary.Container>
        <Summary.Name name={general.name} />
        <Summary.Scheduling scheduling={scheduling} />
        <Summary.SalesChannels salesChannels={restrictions.salesChannels} />
        <Summary.Budget
          budget={restrictions.budget as BaseBudget | undefined}
        />
        <Summary.Sellers sellers={restrictions.sellers} />
        <Summary.ProgressiveDiscount discount={progressive} />
        <Summary.Conditions conditions={conditions} />
        <Summary.Restrictions restrictions={restrictions} />
        <Summary.Accumulate
          restrictions={restrictions}
          discountType={discountType}
        />
      </Summary.Container>
    </>
  )
}
